import Component from 'vue-class-component';
import { Prop, Watch, Vue } from 'vue-property-decorator';

@Component
export default class TableFilterStringComponent extends Vue {
  @Prop()
  fieldName: string;

  @Prop()
  criteriaType: string;

  @Prop()
  defaultValue: string;

  @Prop()
  selectedFilterValue: string;

  value = '';

  /**
   * initialize component
   */
  mounted() {
    this.value = this.defaultValue ? this.defaultValue : '';
  }

  @Watch('value')
  onPropertyChanged() {
    setTimeout(
      function () {
        this.$emit('updateCriteria', this.fieldName + '.' + this.criteriaType, this.value);
      }.bind(this),
      500
    );
  }

  @Watch('selectedFilterValue')
  onPropertyChangedSelected() {
    this.value = this.selectedFilterValue
  }

}
